module.exports = __webpack_public_path__ + "static/media/detail_bloodTest_pg1.beaddb17.png";